<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="folkCode">Đào tạo bồi dưỡng về giáo dục người khuyết tật</nz-form-label>
          <nz-form-control nzSpan="24">
            <asc-autocomplete label="đào tạo bồi dưỡng về giáo dục người khuyết tật" [ascModel]="DiplomaControl"
              (ascModelChange)="changeDiploma($event)" placeholder="Chọn đào tạo bồi dưỡng về giáo dục người khuyết tật..." formControlName="diplomaId"
              [getListAC]="getDiplomaACFn"> 
            </asc-autocomplete>
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="disCertificateOfStaffName" nzRequired>Tên chứng chỉ</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="disCertificateOfStaffName" name="disCertificateOfStaffName" placeholder="Nhập tên chứng chỉ">
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="disCertificateOfStaffCourse" nzRequired>Khóa học</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="disCertificateOfStaffCourse" name="disCertificateOfStaffCourse" type="text" placeholder="Nhập khóa học">
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="studyTime" nzRequired>Thời gian</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="studyTime" name="studyTime" type="text" placeholder="Nhập thời gian">
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="note">Ghi chú</nz-form-label>
          <nz-form-control nzSpan="24">
            <input nz-input formControlName="note" name="note" type="text" placeholder="Nhập thời gian">
          </nz-form-control>
        </nz-form-item >
      </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <popup-btn-footer 
      [isDisableUpdate]="false" 
      [isUpdateAndAdd]="false" 
      [isUpdateAndClose]="true" 
      (updateAndClose)="UpdateClose()"
      (close)="close()"
      ></popup-btn-footer>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <popup-btn-footer 
      [isDisableUpdate]="false" 
      [isUpdateAndAdd]="false"
      [isUpdateAndClose]="true" 
      (updateAndClose)="UpdateClose()"
      (close)="close()"
      ></popup-btn-footer>
    </div>
  </div>
</form>